import React from 'react';
import PropTypes from 'prop-types';

import styles from './Checkbox.css';

const IPropTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {
  className: '',
  checked: false,
  onClick: () => {},
};

const clickEvent = callback => (event) => {
  event.preventDefault();
  callback();
};

const Checkbox = props => (
  <button
    className={[
      props.className,
      styles.container,
      props.checked ? styles.checked : ''].join(' ')
    }
    onClick={clickEvent(props.onClick)}
  >
    {/* The check is always rendered to avoid issues with checkbox sizing.
        When unchecked it's transparent.
    */}
    ✔
  </button>
);

Checkbox.propTypes = IPropTypes;
Checkbox.defaultProps = defaultProps;

export { Checkbox };



// WEBPACK FOOTER //
// ./src/common/checkbox/Checkbox.jsx